
import { Component, Prop, Vue , Watch} from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import moment from 'moment';

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import VisitCreateForm from "@/form/visits/visitCreate";
import VisitGeneralForm from "@/form/visits/visitGeneral";

import { mixins } from 'vue-class-component';
import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
import { VisitsStore } from "@/store/modules/Visits";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";

@Component({
    components: { FormGroup },
    methods: { moment }
})
export default class VisitServiceMultyDetail extends mixins(Vue, VisitsGeneralMix) {
    @Prop() value!: any;
    @Prop() form!:  VisitGeneralForm;

    changeQuantity(value: number | string, index: number): void {
        //this.values[index].quantity = value;
        this.updateValue();
    }

    updateValue() {
        this.$emit('input', this.form.service_data);
    }

    deleteValue(index : any) {
        this.form.service_data?.splice(index, 1);
        this.$emit('input', this.form.service_data);
    }

    addValue() {
      this.form.service_data?.push({});
      console.log('11W');
      this.$emit('input', this.form.service_data);
    } 

    get service(): IServices | null {
        return ServiceStore.service;
    }
            
    async created(): Promise<void> {
        await ServiceStore.fetchAll({filter: {salon_id: this.form.salon_id}});
        await VisitsStore.fetchData({ filter: { id: this.form.id } });

        if(this.visit && this.visit.basket) {
            this.form.service_data = [];
            this.form.total_amount = 0;
            for(let i = 0; i < this.visit.basket.services.length; i++)
            {
                this.form.service_data.push({
                    'service_id':   this.visit.basket.services[i].service_id,
                    'price':        this.visit.basket.services[i].price,
                    'quantity':     this.visit.basket.services[i].quantity,
                });

                 this.form.total_amount += this.visit.basket.services[i].price * this.visit.basket.services[i].quantity;
            }
        }
    }
}
